import { useContext } from "react";
import { ActionButtonsContext } from "contexts/ActionButtonsContext";

// ==============================|| CONFIG - HOOKS  ||============================== //

const useActionButtons = () => useContext(ActionButtonsContext);

export default useActionButtons;